import React, { useCallback } from 'react';

import { EntityCollectionAutocomplete, EntityCollectionAutocompleteProps } from 'app/components';
import { GeneralConstants } from 'app/constants';
import { Brand } from 'app/model';
import { searchService } from 'app/services';

type EntityBrandCollectionAcProps<T extends object> = Omit<
    EntityCollectionAutocompleteProps<T, Brand>,
    'getOptionLabel' | 'onSearch'
>;

const getOptionLabel = (option: Brand) => option.name;

export const EntityBrandCollectionAc = <T extends object>(
    props: EntityBrandCollectionAcProps<T>,
): React.ReactElement => {
    const onSearch = useCallback((data: string) => searchService.search(data, 1, GeneralConstants.PAGE_SIZE_LARGE), []);

    return <EntityCollectionAutocomplete {...props} getOptionLabel={getOptionLabel} onSearch={onSearch} />;
};
